module.exports  = {
    floridaMedicine: function(id){
        if(id[0]==="M" && id[1] === "E" && id.length >= 6){
            return true;
        }
        return
    }
}